import React, { useState } from 'react'
import RightArrowIcon from '../../assets/icons/svgComponents/right-arrow-icon'
import Button from '../button'
import * as S from './styles'
import Modal from '../modal'
import RestartImg from '../../assets/imgs/restartImage.png'
import Input from '../input'
import { normalizePhone } from '../../../utils/masks'

type Props ={
  percentil?:number
  classificacao?:string
  handleClick:any
  teste:string
  parametro:string
  tabela:string
  pontuacao?:string
  userData:{
    nome: string,
    email:string,
    telefone: string,
    comentarios: string | null,
  }
  setUserData:any
}
const ThirdStep = ({
  classificacao,
  percentil,
  handleClick,
  teste,
  parametro,
  tabela,
  pontuacao,
  setUserData,
  userData,
}:Props) => {
  const [openModal, setModalOpen] = useState(false)
  const modalHandleClick = async () => {
    await handleClick(userData)
    setModalOpen(false)
    window.location.reload()
  }

  return (
    <S.Wrapper>
      {openModal && (
      <Modal
        closeModal={() => setModalOpen(false)}
        image={(
          <S.ModalImageContainer>
            <h1>Preencha os campos para reiniciar</h1>
            <img src={RestartImg} alt="not found" />
          </S.ModalImageContainer>
)}
        inputs={(
          <S.ModalInputsContainer>
            <form onSubmit={() => {
              window.localStorage.clear()
              localStorage.setItem('notFirstAcess', 'true')
              modalHandleClick()
            }}
            >
              <Input label="Nome" labelColor="black" type="text" name="restartModalName" onChange={(e:any) => setUserData({ ...userData, nome: e.target.value })} />
              <Input
                maxLength={14}
                required
                label="Telefone"
                labelColor="black"
                type="tel"
                value={userData.telefone}
                placeholder="(xx)xxxxxxxx"
                name="sugestionModalPhone"
                onChange={(e:any) => setUserData(
                  { ...userData, telefone: normalizePhone(e.target.value) },
                )}
              />
              <Input required label="Email" labelColor="black" type="email" name="restarModalEmail" onChange={(e:any) => setUserData({ ...userData, email: e.target.value })} />
              <Button
                type="submit"
              >
                Enviar

              </Button>
            </form>
          </S.ModalInputsContainer>
)}
      />
      )}
      <S.ProgressBar>
        <S.Progress stage={3} />
      </S.ProgressBar>
      <h2>
        <div>
          <span>
            Teste:
          </span>
          <span className="results">
            { teste }

          </span>
        </div>
        <div />
        <div>
          <span>
            Parametro:
          </span>
          <span className="results">
            {parametro}
          </span>
        </div>
        <div>
          <span>
            Tabela:
          </span>
          <span className="results">
            {tabela}

          </span>
        </div>
        <div />
        <div>
          <span>
            Pontução:
          </span>
          <span className="results">
            {pontuacao}
          </span>
        </div>
        <div />
        <div className="bodyTitle">
          Resultado:
        </div>
        <div />
      </h2>
      <S.bodyContainer>

        {percentil

            && (
            <h3>
              <span>Percentil:</span>
              <span className="valor">
                { percentil }
              </span>
              <hr />
            </h3>
            )}

        {classificacao
           && (
           <h3>
             <span>Classificação:</span>
             <span className="valor">
               { classificacao }
             </span>
             <hr />
           </h3>
           ) }

      </S.bodyContainer>
      <Button
        className="stepButton"
        onClick={() => {
          if (localStorage.getItem('notFirstAcess') === null) { setModalOpen(true) } else {
            window.localStorage.clear()
            localStorage.setItem('notFirstAcess', 'true')
            window.location.reload()
          }
        }}
      >
        Reiniciar
        <RightArrowIcon color="white" />
      </Button>
    </S.Wrapper>
  )
}
export default ThirdStep
